export default "// Type your solution below\ntype parameter = [\"Set_ship_code\", string] | [\"Go_to\", string];\n";